import { render, staticRenderFns } from "./FormCertificationContent.vue?vue&type=template&id=7613c56e&"
import script from "./FormCertificationContent.vue?vue&type=script&lang=js&"
export * from "./FormCertificationContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports